import { ReactNode } from 'react';

import {
  Barber,
  Hospital,
  Laboratory,
  Pharmacy,
  Shelter,
  Ritual,
  Shop,
  Hotel,
  Equipment,
  Aquarium,
  Expertise
} from '../ui';

const catNames = [
  'Ветеринарная клиника',
  'Ветеринарная аптека',
  'Ветеринарная лаборатория',
  'Гостиница для животных',
  'Зоомагазин',
  'Зоосалон, зоопарикмахерская',
  'Ветеринарные препараты и оборудование',
  'Ритуальные услуги для животных',
  'Лаборатория ветеринарно-санитарной экспертизы',
  'Министерства, ведомства, государственные службы',
  'Органы государственного надзора',
  'Комбикорма и кормовые добавки',
  'Сельскохозяйственная техника, оборудование',
  'Аквариумы',
  'Аптека',
  'Медицинская лаборатория',
  'Оптовая компания',
  'Дезинфекция, дезинсекция, дератизация',
  'Товары для рыбалки',
  'Приют для животных'
] as const;

type CatName = (typeof catNames)[number];

type ServiceObject = { [key in CatName]: { icon: ReactNode; text: string } };

// TODO: Extend
const servicesObject = {
  'Ветеринарная клиника': {
    icon: <Hospital />,
    text: 'Ветеринарная клиника'
  },
  'Ветеринарная аптека': {
    icon: <Pharmacy />,
    text: 'Ветеринарная аптека'
  },
  Зоомагазин: {
    icon: <Shop />,
    text: 'Зоомагазин'
  },
  'Ветеринарная лаборатория': {
    icon: <Laboratory />,
    text: 'Ветеринарная лаборатория'
  },
  'Ритуальные услуги для животных': {
    icon: <Ritual />,
    text: 'Ритуальные услуги для животных'
  },
  'Зоосалон, зоопарикмахерская': {
    icon: <Barber />,
    text: 'Зоосалон, зоопарикмахерская'
  },
  'Гостиница для животных': {
    icon: <Hotel />,
    text: 'Гостиница для животных'
  },
  'Ветеринарные препараты и оборудование': {
    icon: <Equipment />,
    text: 'Ветеринарные препараты и оборудование'
  },
  Аквариумы: {
    icon: <Aquarium />,
    text: 'Аквариумы'
  },
  'Медицинская лаборатория': {
    icon: <Laboratory />,
    text: 'Медицинская лаборатория'
  },
  'Приют для животных': {
    icon: <Shelter />,
    text: 'Приют для животных'
  },
  'Лаборатория ветеринарно-санитарной экспертизы': {
    icon: <Expertise />,
    text: 'Лаборатория ветеринарно-санитарной экспертизы'
  }
} as ServiceObject;

export default servicesObject;
